import React from 'react';

const SectionHeader = ({ title }) => (
    <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 bg-gray-100 dark:bg-gray-700/50 p-3 my-4 rounded-md">{title}</h3>
);

export default SectionHeader; 